import { queryOptions } from '@tanstack/react-query';
import fileDetailDefaultDataGenerator from '@/modules/FileDetail/data/fileDetail/fileDetailDefaultDataGenerator.ts';
import { fileEntryQueryFunction } from '@/modules/FileDetail/queries/fileEntry/fileEntryQueryFunction.ts';

export const fileEntryQueryOptions = (id: string) =>
  queryOptions({
    queryKey: ['file_entry', id],
    queryFn: () => fileEntryQueryFunction(id),
    enabled: !!id,
    select(data) {
      return {
        ...data,
        detailCardItems: fileDetailDefaultDataGenerator(data),
      };
    },
  });
